"use client";

import AffirmLogo from "component/logo/AffirmLogo";
import { RootState } from "interfaces/generics.type";
import Link from "next/link";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import yieldToMain from "util/lodash/yieldToMain";
import { PRODUCT_PAGE_TYPES } from "util/product/product-constants";
import PAText from "../typography/PAText/PAText";
import styles from "./affirmPriceWidget.module.scss";

export default function AffirmPriceWidget({ amount }) {
  const currentPageType = useSelector((state: RootState) => state.utils.currentPageType);
  // const ref = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    yieldToMain().then(() => {
      if (window.affirm) {
        window.affirm.jsReady(() => {
          window.affirm.ui.refresh();
        });
      }
    });
  }, []);

  if (PRODUCT_PAGE_TYPES.includes(currentPageType)) {
    return (
      <div
        className={`affirm-as-low-as ${styles.affirm_ala}`}
        data-page-type="product"
        data-amount={amount}
      />
    );
  }
  return (
    <Link className={styles.link_text} href="/financing">
      <PAText>
        Pay at Your Own Pace, Starting at 0% APR with
      </PAText>
      &nbsp;
      <AffirmLogo width={55} height={22} className={styles.affirm_logo} />
    </Link>
  );
}
